import React from 'react';
typeof window !== 'undefined' &&
    !window.__DS_WEB_VERSION__ &&
    (window.__DS_WEB_VERSION__ = '2.4.0');
import { containerDefaultProps } from './props';
import * as S from './style';
export const Container = (props) => (React.createElement(S.ContainerWrapper, Object.assign({ "data-ds-component": "DS-Container" }, props), props.children));
Container.defaultProps = containerDefaultProps;
Container.displayName = 'DS-Container';
